import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setToken } from '../services/api';

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double execution in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const fragment = window.location.hash.substring(1);
        const params = new URLSearchParams(fragment);
        const sessionId = params.get('session_id');

        if (!sessionId) {
          console.error('No session_id found');
          navigate('/login');
          return;
        }

        // Exchange session_id for user data
        const API_URL = window.location.origin 
          ? `${window.location.origin}/api`
          : window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
          ? 'http://localhost:8001/api'
          : '/api';

        console.log('Exchanging session_id:', sessionId);
        console.log('API URL:', API_URL);
        
        const response = await fetch(`${API_URL}/auth/session`, {
          method: 'GET',
          headers: {
            'X-Session-ID': sessionId,
            'Content-Type': 'application/json'
          },
          credentials: 'include'
        });

        console.log('Response status:', response.status);
        
        // Read response body as text first (can only be read once)
        const responseText = await response.text();
        
        if (!response.ok) {
          console.error('Session exchange failed:', response.status, responseText);
          throw new Error('Failed to exchange session');
        }

        // Parse JSON from the text we already read
        const data = responseText ? JSON.parse(responseText) : {};
        console.log('Session data received:', data);
        
        // IMPORTANT: Save the session token so isAuthenticated() returns true
        if (data.session_token) {
          setToken(data.session_token);
          console.log('Session token saved successfully');
        }
        
        // Navigate to dashboard with user data
        navigate('/dashboard', { 
          replace: true,
          state: { user: data.user }
        });

      } catch (error) {
        console.error('Error processing session:', error);
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-50 to-blue-50">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mb-4"></div>
        <p className="text-gray-600">Connexion en cours...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
